<template>
    <div>
        <div v-show="timer.residual_water_time ? false : true" class="dashboard cust-drivers cust-drivers--loader">
            <Loader :loader="timer.residual_water_time ? false : true" />
        </div>
        <div v-show="!residualWaterTime" class="dashboard cust-drivers cust-drivers--worktime cust-water-time">
            <!-- <h1 v-show="timer.residual_water_time">残水時刻を記録してください</h1> -->
            <div class="cust-drivers__menu">
                <ul>
                    <li v-show="timer.residual_water_time" class="cust-drivers__menu__item">
                        <input v-model="timer.residual_water_time" class="cust-drivers__menu__input cust-drivers__menu__input--waterTime" type="time">
                        <button class="is-timer is-timer--waterTime" :class="timerButton.residual_water_time" type="button" @click="handleUpdateResidualWater()">
                            <!-- {{ timer.residual_water_time }} -->
                            <span class="cust-drivers__menu__head">
                                残水確認<br>
                                <strong>出荷開始</strong>
                            </span>
                        </button>
                    </li>
                </ul>
            </div>
        </div>
        <div v-show="residualWaterTime" class="dashboard cust-drivers">
            <div class="cust-drivers__menu">
                <ul>
                    <li v-show="timerButton.site_arrival_time === timerButton.buttonActive" class="cust-drivers__menu__item">
                        <input v-model="timer.site_arrival_time" class="cust-drivers__menu__input" type="time">
                        <button class="is-timer" :class="timerButton.site_arrival_time" type="button" @click="handleUpdateSiteArrival()">
                            <span class="cust-drivers__menu__head">現場<strong>着</strong> 保存</span>
                            <!-- {{ timer.site_arrival_time }} -->
                        </button>
                    </li>
                    <li v-show="timerButton.site_departure_time === timerButton.buttonActive" class="cust-drivers__menu__item">
                        <input v-model="timer.site_departure_time" class="cust-drivers__menu__input" type="time">
                        <button class="is-timer is-timer-color-b" :class="timerButton.site_departure_time" type="button" @click="handleUpdateSiteDeparture()">
                            <span class="cust-drivers__menu__head">現場<strong>発</strong> 保存</span>
                            <!-- {{ timer.site_departure_time }} -->
                        </button>
                    </li>
                    <li v-show="timerButton.factory_arrival_time === timerButton.buttonActive" class="cust-drivers__menu__item">
                        <input v-model="timer.factory_arrival_time" class="cust-drivers__menu__input" type="time">
                        <button class="is-timer is-timer-color-r" :class="timerButton.factory_arrival_time" type="button" @click="handleUpdateFactoryArrival()">
                            <span class="cust-drivers__menu__head">工場<strong>着</strong> 保存</span>
                            <!-- {{ timer.factory_arrival_time }} -->
                        </button>
                    </li>
                </ul>
            </div>
            <div class="cust-drivers__contents">
                <h1 class="l-mt2">
                    <template v-if="dataDeliveryDestination.contractor">
                        {{ dataDeliveryDestination.contractor }}<br>
                    </template>
                    {{ dataDeliveryDestination.delivery_destination_name }}
                </h1>
                <div class="l-mb4">
                    <div class="l-mb2 is-center">
                        <template v-if="dataDeliveryDestination.image1">
                            <a v-if="flagFilesExtension.image1" :href="`${filesUrl}${dataDeliveryDestination.image1}`" target="_blank">
                                <img src="@/assets/images/pdf-image.png" alt="">
                            </a>
                            <img v-else :src="`${filesUrl}${dataDeliveryDestination.image1}`" :alt="dataDeliveryDestination.delivery_destination_name">
                        </template>
                    </div>
                    <div class="is-center">
                        <template v-if="dataDeliveryDestination.image2">
                            <a v-if="flagFilesExtension.image2" :href="`${filesUrl}${dataDeliveryDestination.image2}`" target="_blank">
                                <img src="@/assets/images/pdf-image.png" alt="">
                            </a>
                            <img v-else :src="`${filesUrl}${dataDeliveryDestination.image2}`" :alt="dataDeliveryDestination.delivery_destination_name" @click="openEnlargedView(`${filesUrl}${dataDeliveryDestination.image2}`)">
                        </template>
                    </div>
                    <!-- <div class="is-center">
                        <template v-if="dataDeliveryDestination.image3">
                            <a v-if="flagFilesExtension.image3" :href="`${filesUrl}${dataDeliveryDestination.image3}`" target="_blank">
                                <img src="@/assets/images/pdf-image.png" alt="">
                            </a>
                            <img v-else :src="`${filesUrl}${dataDeliveryDestination.image3}`" :alt="dataDeliveryDestination.delivery_destination_name" @click="openEnlargedView(`${filesUrl}${dataDeliveryDestination.image3}`)">
                        </template>
                    </div> -->
                </div>
                <table class="l-mb4">
                    <tr>
                        <th>車両ID</th>
                        <td class="is-wrap">{{ dataDeliveryDestination.vehicle_id }}</td>
                    </tr>
                    <tr>
                        <th>先発車両ID</th>
                        <td class="is-wrap">
                            {{ dataDeliveryDestination.before_vehicle_id !== "0" ? dataDeliveryDestination.before_vehicle_id : "" }}
                            {{ dataDeliveryDestination.before_vehicle_site_departure_time ? `(${dataDeliveryDestination.before_vehicle_site_departure_time.split(' ')[1]} 現場発)` : "" }}
                        </td>
                    </tr>
                    <tr>
                        <th>納入先住所</th>
                        <td class="is-wrap">{{ dataDeliveryDestination.delivery_destination_address }}</td>
                    </tr>
                </table>
                <div ref="googleMap" style="height:320px;"></div>
                <div class="l-mt4 is-right">
                    <button class="button--primary" @click="reload()">情報更新ボタン</button>
                </div>
            </div>
            <div v-if="backdropImagePath" class="backdrop" @click="closeEnlargedView()">
                <img :src="backdropImagePath" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    "use strict";

    import Loader from "@/components/DriversLoader.vue";

    import common from "@/mixins/common";
    import gmap from "@/mixins/gmap";

    const audio = new Audio(`${common.$_configs.filesUrl}/button.mp3`);

    export default {
        "components": {
            Loader,
        },
        "mixins": [
            common,
            gmap,
        ],
        data() {
            return {
                "backdropImagePath": "",
                "dataDeliveryDestination": {},
                "flagFilesExtension": {
                    "image1": false,
                    "image2": false,
                    "image3": false,
                },
                "filesUrl": common.$_configs.filesUrl,
                "mapFlag": false,
                "residualWaterTime": false,
                "timer": {
                    "factory_departure_time": "",
                    "site_arrival_time": "",
                    "site_departure_time": "",
                    "factory_arrival_time": "",
                    "residual_water_time": "",
                },
                "timerButton": {
                    "buttonActive": "button--oval--other",
                    "buttonPassive": "button--oval--cancel",
                    "factory_departure_time": "",
                    "site_arrival_time": "",
                    "site_departure_time": "",
                    "factory_arrival_time": "",
                    "residual_water_time": "",
                    "interval": "",
                },
            };
        },
        created() {
            this.fetchingDataDeliveryDestination();
        },
        "methods": {
            reload() {
                location.reload();
            },
            openEnlargedView(imagePath) {
                this.backdropImagePath = imagePath;
            },
            closeEnlargedView() {
                this.backdropImagePath = "";
            },
            checkingFilesExtension(fileNames) {
                // 拡張子がpdfかを判別
                for (let fileName of fileNames) {
                    const extension = this.dataDeliveryDestination[fileName].split(".").slice(-1)[0].toLowerCase();
                    if (extension === "pdf") {
                        this.flagFilesExtension[fileName] = true;
                    }
                }
            },
            timerStart(timerName) {
                const today = new Date();
                this.timer[timerName] = `${today.getHours()}:${("0" + today.getMinutes()).slice(-2)}`;
                // 日時入力の自動化を停止
                // this.timerButton.interval = setInterval(() => {
                //     const today = new Date();
                //     this.timer[timerName] = `${today.getHours()}:${("0" + today.getMinutes()).slice(-2)}:${("0" + today.getSeconds()).slice(-2)}`;
                // }, 1000);
            },
            timerStop() {
                // 日時入力の自動化を停止
                // clearInterval(this.timerButton.interval);
            },
            timerSwitching() {
                // 現在登録されている時刻を一度取得する
                // 工場発時刻（元・残水時刻）は絶対に空なのでそれを利用する
                // 工場発時刻（元・残水時刻）は廃止されたため工場着時刻に変更
                common.$_axios.post(
                    `${common.$_configs.apiUrl}/driving_time/${this.dataDeliveryDestination.delivery_allocations_id}`, {
                        "factory_arrival_time": "",
                    },
                    this.$_requestConfig()
                ).then((response) => {
                    this.timer.factory_departure_time = "";
                    this.timer.site_arrival_time = "";
                    this.timer.site_departure_time = "";
                    this.timer.factory_arrival_time = "";
                    this.timer.residual_water_time = "";
                    this.timerButton.factory_departure_time = this.timerButton.buttonPassive;
                    this.timerButton.site_arrival_time = this.timerButton.buttonPassive;
                    this.timerButton.site_departure_time = this.timerButton.buttonPassive;
                    this.timerButton.factory_arrival_time = this.timerButton.buttonPassive;
                    this.timerButton.residual_water_time = this.timerButton.buttonActive;
                    this.residualWaterTime = false;
                    this.updateTime(response.data);
                });
            },
            updateTime(data) {
                delete data.factory_departure_time;
                // delete data.residual_water_time;
                if (!data.residual_water_time) {
                    this.timerStart("residual_water_time");
                } else {
                    this.residualWaterTime = true;
                    let timerKey = "";
                    for (let key in data) {
                        const time = data[key].split(" ");
                        if (time[1] && time[1] !== "00:00") {
                            this.timer[key] = time[1];
                            this.timerButton[key] = this.timerButton.buttonPassive;
                        } else {
                            this.timer[key] = "00:00";
                            if (!timerKey) {
                                timerKey = key;
                                this.timerStart(timerKey);
                                // 工場に戻るターンは地図を工場に変更する
                                // 位置情報による自動打刻のため実装
                                if (timerKey === "factory_arrival_time") {
                                    this.$_gmap({
                                        "address": "名古屋市守山区藪田町805番地",
                                        "lat": 35.19901973951638,
                                        "lng": 136.99357429029007,
                                        "current": true,
                                        "range": 300,
                                    });
                                } else {
                                    if (!this.mapFlag) {
                                        this.$_gmap({
                                            "address": this.dataDeliveryDestination.delivery_destination_address,
                                            "lat": this.dataDeliveryDestination.delivery_destination_address_lat,
                                            "lng": this.dataDeliveryDestination.delivery_destination_address_lng,
                                        });
                                        this.mapFlag = true;
                                    }
                                }
                                this.timerButton[key] = this.timerButton.buttonActive;
                            }
                        }
                    }
                }
            },
            $_gmapRangeAction(result) {
                // GoogleMap範囲内判定の処理をmixin上書きで処理する
                if (result) {
                    this.handleUpdateFactoryArrival();
                }
            },
            fetchingDataDeliveryDestination() {
                // 納入先データ（ドライバー用）取得
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/delivery_destinations/driver`,
                    this.$_requestConfig()
                ).then((response) => {
                    this.dataDeliveryDestination = response.data;
                    if (this.dataDeliveryDestination.vehicle_inspection_dates === "0") {
                        this.$router.push({ "name": "drivers_vehicle_inspection_dates_create", "params": { "id": String(this.dataDeliveryDestination.vehicle_id) }});
                    } else if (this.dataDeliveryDestination.vehicle_inspection_dates === "1") {
                        this.checkingFilesExtension(["image1", "image2", "image3"]);
                        this.timerSwitching();
                    }
                    this.checkingFilesExtension(["image1", "image2", "image3"]);
                    this.timerSwitching();
                }).catch(() => {
                    this.$router.push({ "name": "drivers_work_times" });
                });
            },
            handleUpdateFactoryDeparture() {
                if (this.timerButton.factory_departure_time === this.timerButton.buttonActive) {
                    this.timerStop();
                    
                    let minutes = this.timer.factory_departure_time.split(":", 2);
                    minutes = minutes.join(":");
                    const timeData = `${this.dataDeliveryDestination.delivery_destination_date} ${minutes}`;

                    // 運転時刻データ更新（工場発時刻）
                    common.$_axios.post(
                        `${common.$_configs.apiUrl}/driving_time/${this.dataDeliveryDestination.delivery_allocations_id}`, {
                            "factory_departure_time": timeData,
                        },
                        this.$_requestConfig()
                    ).then((response) => {
                        this.updateTime(response.data);
                    }).catch(() => {
                        alert("工場発時刻の更新に失敗しました。");
                    });
                }
            },
            handleUpdateSiteArrival() {
                audio.play();
                if (this.timerButton.site_arrival_time === this.timerButton.buttonActive && this.timer.site_arrival_time !== "00:00") {
                    this.timerStop();

                    let minutes = this.timer.site_arrival_time.split(":", 2);
                    minutes = minutes.join(":");
                    const timeData = `${this.dataDeliveryDestination.delivery_destination_date} ${minutes}`;

                    // 運転時刻データ更新（現場着時刻）
                    common.$_axios.post(
                        `${common.$_configs.apiUrl}/driving_time/${this.dataDeliveryDestination.delivery_allocations_id}`, {
                            "site_arrival_time": timeData,
                        },
                        this.$_requestConfig()
                    ).then((response) => {
                        this.updateTime(response.data);
                    }).catch(() => {
                        alert("現場着時刻の更新に失敗しました。");
                    });
                }
            },
            handleUpdateSiteDeparture() {
                audio.play();
                if (this.timerButton.site_departure_time === this.timerButton.buttonActive && this.timer.site_departure_time !== "00:00") {
                    this.timerStop();

                    let minutes = this.timer.site_departure_time.split(":", 2);
                    minutes = minutes.join(":");
                    const timeData = `${this.dataDeliveryDestination.delivery_destination_date} ${minutes}`;

                    // 運転時刻データ更新（現場発時刻）
                    common.$_axios.post(
                        `${common.$_configs.apiUrl}/driving_time/${this.dataDeliveryDestination.delivery_allocations_id}`, {
                            "site_departure_time": timeData,
                        },
                        this.$_requestConfig()
                    ).then((response) => {
                        this.updateTime(response.data);
                    }).catch(() => {
                        alert("現場発時刻の更新に失敗しました。");
                    });
                }
            },
            handleUpdateFactoryArrival() {
                audio.play();
                if (this.timerButton.factory_arrival_time === this.timerButton.buttonActive && this.timer.factory_arrival_time !== "00:00") {
                    this.timerStop();

                    let minutes = this.timer.factory_arrival_time.split(":", 2);
                    minutes = minutes.join(":");
                    const timeData = `${this.dataDeliveryDestination.delivery_destination_date} ${minutes}`;

                    // 運転時刻データ更新（工場着時刻）
                    common.$_axios.post(
                        `${common.$_configs.apiUrl}/driving_time/${this.dataDeliveryDestination.delivery_allocations_id}`, {
                            "factory_arrival_time": timeData,
                        },
                        this.$_requestConfig()
                    ).then(() => {
                        setTimeout(() => {
                            this.fetchingDataDeliveryDestination();
                        }, 1000);
                    }).catch(() => {
                        alert("工場着時刻の更新に失敗しました。");
                    });
                }
            },
            handleUpdateResidualWater() {
                audio.play();
                if (this.timerButton.residual_water_time === this.timerButton.buttonActive && this.timer.residual_water_time !== "00:00") {
                    this.timerStop();

                    let minutes = this.timer.residual_water_time.split(":", 2);
                    minutes = minutes.join(":");
                    const timeData = `${this.dataDeliveryDestination.delivery_destination_date} ${minutes}`;

                    // 運転時刻データ更新（残水確認・工場発時刻）
                    common.$_axios.post(
                        `${common.$_configs.apiUrl}/driving_time/${this.dataDeliveryDestination.delivery_allocations_id}`, {
                            "residual_water_time": timeData,
                        },
                        this.$_requestConfig()
                    ).then(() => {
                        this.residualWaterTime = true;
                        setTimeout(() => {
                            this.fetchingDataDeliveryDestination();
                        }, 1000);
                    }).catch(() => {
                        alert("残水確認・工場発時刻の更新に失敗しました。");
                    });
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    h1 {
        font-size: 26px;
        line-height: 1.1;
    }
</style>
